const formatedFlags = (flag) => {
  return '\\' + flag;
};

export default formatedFlags;
